// 简体中文
export default {
	common: {
		requestFailed: '请求失败',
		needLogin: '请先登录',
		accountLoggedOut: '账号已登出',
		confirm: '确认',
		cancel: '取消',
	},
	nav: {
		home: '首页',
		list: '列表',
		game: '投票',
		video: '影视',
		mine: '我的',
	},
	route: {
		home: '首页',
		choose: '选妃',
		list: '选妃列表',
		profile: '详情信息',
		mine: '我的',
		video: '视频',
		game: '游戏',
		login: '登录',
		register: '注册',
		serviceOnline: '在线客服',
		servicePage: '在线客服',
		setting: '设置',
		infomation: '基本信息',
		setname: '修改真实姓名',
		setsex: '修改性别',
		setPayPassword: '管理支付密码',
		setLoginPassword: '管理登录密码',
		lottery: '详情页',
		notice: '公告',
		playVideo: '视频播放',
		setbank: '填写收款银行卡信息',
		bindCard: '绑定银行卡',
		withdraw: '提现',
		personalreport: '个人报表',
		withdrawRecord: '提现记录',
		gameRecord: '任务记录',
	},
	page: {
		login: {
			title: '登录',
			usernamePlaceholder: '请输入用户名',
			passwordPlaceholder: '请输入密码',
			forgotPassword: '忘记密码？',
			registerPrompt: '还没有账号？立即注册',
			loginBtn: '登录',
			enterUsername: '请输入用户名！',
			enterPassword: '请输入密码！',
		},
		mine: {
			recharge: '充值',
			withdraw: '提现',
			myWallet: '我的钱包',
			detail: '明细',
			balance: '余额',
			personalReport: '个人报表',
			accountDetail: '账户明细',
			taskRecord: '任务记录',
			profileCenter: '个人中心',
			notice: '公告',
			onlineService: '在线客服',
			refreshSuccess: '刷新成功',
			exitTaskWarn: '请先完成任务再离开',
			rechargeContactService: '请联系客服充值',
			setBankCardFirst: '请先设置收款银行卡信息！',
			functionDisabled: '功能已禁用！',
			guestUsername: '登录/注册',
			guestSubtitle: '登录以体验更多服务！',
		},
		setting: {
			navTitle: '设置',
			basicInfoSetting: '基本资料设置',
			loginPassword: '登录密码',
			payPassword: '支付密码',
			payPasswordSet: '已设置',
			payPasswordUnset: '未设置',
			logout: '退出登录',
			payPasswordAlreadySet: '提现密码已设置，如需修改，请联系客服',
			language: '切换语言',
		},
		infomation: {
			navTitle: '基本信息',
			avatar: '头像',
			selectAvatar: '选择头像',
			realName: '真实姓名',
			notSet: '未设置',
			gender: '性别',
			genderUndefined: '未确定',
			male: '男',
			female: '女',
			bankBinding: '绑定银行卡',
			linked: '已绑定',
			none: '无',
		},
		setname: {
			navTitle: '修改真实姓名',
			save: '保存',
			name: '姓名',
			namePlaceholder: '请输入真实姓名',
			nameWarn: '为确保您的账户安全，真实姓名需与已绑定的银行卡姓名一致',
			dontSetAgain: '请勿重复设置！',
			enterName: '请输入姓名！',
		},
		setsex: {
			navTitle: '修改性别',
			male: '男',
			female: '女',
		},
		setPayPassword: {
			navTitle: '设置支付密码',
			enterPassword: '输入支付密码',
			confirmPassword: '再次输入支付密码',
			fillComplete: '请填写完整',
			passwordMismatch: '两次密码不一致！',
		},
		setLoginPassword: {
			navTitle: '修改登录密码',
			save: '保存',
			oldPassword: '旧密码',
			oldPasswordPlaceholder: '请输入旧密码',
			newPassword: '新密码',
			newPasswordPlaceholder: '请输入新密码',
			confirmPasswordPlaceholder: '请再次输入新密码',
			fillComplete: '请填写完整信息！',
			passwordMismatch: '两次输入的密码不一致',
		},
		notice: {
			navTitle: '系统公告',
			refreshSuccess: '刷新成功',
		},
		serviceOnline: {
			navTitle: '在线客服',
			contact: '联系',
			serviceHours: '7×24小时为您服务',
		},
		servicePage: {
			navTitle: '客服支持',
		},
		withdraw: {
			navTitle: '提现中心',
			history: '提现记录',
			amount: '提现金额',
			all: '全部',
			limit: '提现额度',
			limitPerTransaction: '1. 每笔限额：最低 {min} ，最高 {max} ',
			limitPerDay: '2. 提现次数：每日最多 {num} 次',
			transferTime: '3. 到账时间：通常约5分钟，最快2分钟内',
			balanceLabel: '余额：',
			withdrawNow: '立即提现',
			enterCorrectAmount: '请输入正确的金额',
		},
		withdrawRecord: {
			navTitle: '提现记录',
			noData: '暂无数据！',
			amount: '金额：',
			info: '信息：',
			submitTime: '提交时间：',
			auditTime: '审核时间：',
			refreshSuccess: '刷新成功',
		},
		bindCard: {
			navTitle: '填写收款银行卡信息',
			label: '请输入您的收款银行卡信息',
			accountNumber: '账号',
			accountPlaceholder: '请输入银行账号',
			bank: '银行',
			bankPlaceholder: '请选择银行',
			warn: '亲爱的用户，为保障您的资金安全，请绑定真实姓名并设置提现密码。若姓名与账户名不一致，将无法提现。',
			confirmBind: '确认绑卡',
			enterCardNumber: '请输入银行卡号！',
			selectBank: '请选择银行！',
		},
		setbank: {
			navTitle: '银行卡信息',
			addCard: '添加提现银行卡信息',
			tip: '提示：请绑定大型商业银行，如需更换请联系在线客服',
			setNameFirst: '请先设置姓名再绑定银行卡！',
			setPayPasswordFirst: '请先设置提现密码再绑定银行卡！',
		},
		personalreport: {
			navTitle: '个人报表',
			profitTitle: '盈亏金额（单位：盾）',
			profitFormula: '盈亏公式：中奖金额 - 投注金额',
			taskMoney: '投注金额',
			rechargeMoney: '充值金额',
			withdrawMoney: '提现金额',
			winMoney: '中奖金额',
		},
		gameRecord: {
			navTitle: '任务记录',
			noData: '暂无数据！',
			betAmount: '投注金额：',
			betTime: '投注时间：',
			updateTime: '更新时间：',
			refreshSuccess: '刷新成功',
			kim: '金',
			moc: '木',
			thuy: '水',
			hoa: '火',
		},
		home: {
			recommendTask: '推荐任务',
			viewMore: '查看更多',
			popularRanking: '热门排行',
			hotRecommend: '热门推荐',
			playCount: '播放:',
			loadingData: '正在获取数据...',
			refreshSuccess: '刷新成功',
		},
		choose: {
			navTitle: '想要约会吗？',
			city: '城市',
			cityDesc: ' 社区是顶级信誉平台，为您分享最可靠的信息。我们承诺提供一个信誉良好、健康且保护客户隐私的场所。',
			processAndPrice: '流程与价格',
			processDesc: '本网站提供同城外围、商务陪练和情感相关服务。为保护每位用户的隐私，客户仅可通过联系接待人员或平台高级成员加入。',
			resourcesTitle: '有哪些资源？',
			resourcesContent: '可以找到知名艺人、模特、空姐、年轻模特、大学生，在这个平台没有不可能',
			serviceScopeTitle: '服务范围？',
			serviceScopeContent1: '同城免费约会，覆盖全国所有地点，在各大城市均有覆盖，也可通过联系接待人员安排。',
			serviceScopeContent2: '本网站提供同城外围、商务陪练和情感相关服务。为保护每位用户的隐私，客户仅可通过联系接待人员或平台高级成员加入。',
		},
		list: {
			refreshSuccess: '刷新成功',
		},
		profile: {
			navTitle: '选妃',
			bookAppointment: '预约',
			contactConsultant: '请联系顾问或前台',
		},
		video: {
			navTitle: '影院',
			noMore: '没有更多了',
			playCount: '播放:',
			refreshSuccess: '刷新成功',
		},
		playVideo: {
			playCount: '次播放',
			hotRecommend: '热门推荐',
			rechargeToWatch: '请先充值观看视频！',
		},
		game: {
			navTitle: '投票大厅',
			all: '全部',
			refreshSuccess: '刷新成功',
		},
		register: {
			title: '注册',
			usernamePlaceholder: '请输入用户名（6-12位字母或数字）',
			passwordPlaceholder: '请输入密码（6-12位字母或数字）',
			codePlaceholder: '请输入邀请码',
			agreementText: '我已阅读并同意《账户协议》条款',
			registerBtn: '注册',
			enterUsername: '请输入用户名！',
			enterPassword: '请输入密码！',
			enterCode: '请输入邀请码！',
			agreeTerms: '请同意下方条款！',
		},
		lottery: {
			taskHistory: '任务记录',
			rules: '游戏规则',
			playHint: '玩法提示',
			playHintDetail: '从可选的形式和数值中选择数字进行投注',
			prizeGuide: '中奖指南',
			prizeGuideDetail: '三个中奖数字总和11-18为大；3-10为小；',
			betExample: '投注示例',
			betExampleDetail: '投注示例：小 开奖结果：123，即中 小',
			taskOrder: '任务订单',
			availableBalance: '可用余额',
			currency: '分数',
			submit: '提交',
			currentChoice: '当前选择：',
			betAmount: '投注金额：',
			enterAmount: '请输入金额',
			selected: '已选',
			total: '总计',
			orderDetail: '1 x {money}đ = {money} ',
			clearOrder: '清除订单',
			confirmSubmit: '确认提交',
			periodNumber: '期号',
			resultNumber: '开奖号码',
			notSelected: '未选择',
			invalidAmount: '金额无效！',
			selectNumber: '请选择号码！',
			enterAmountWarn: '请输入金额！',
			insufficientBalance: '余额不足，请联系客服充值！',
			refreshSuccess: '刷新成功',
			contactAdminForTask: '请联系管理员领取此任务！',
			lotteryResultPeriod: '开奖结果，期号：{period}',
			
			lotterynow: '本期',
			lotterying: '正在进行投票',
			lottery_da: '火箭',
			lottery_xiao: '心',
			lottery_dan: '游艇',
			lottery_shuang: '玫瑰',
			lottery_piao:'票',
			lottery_his:'历史',
			lottery_log:'记录',
			lottery_sec:'投票选择',
			
			
		},
		ordlan: {
			"PopularMembers": "热门会员",
			"Rating": "评分",
			"AppointmentRequest": "预约申请",
			"PersonalVideoVerification": "个人视频认证",
			"IdentityVerification": "身份认证",
			"ManagerProfile": "管理员资料",
			"ServiceArea": "服务区域",
			"TravelAvailable": "可外出服务",
			"Yes": "是",
			help:'帮助',
			AgencyBooking:'代理预订',
			More:'更多',
		}
	},
}
